import { getSalesItemsList } from "app/components/sidebar3/dynamic-config/configs/sidebar31/getSalesItemsList";
import { secondarySidebarMap } from "app/components/sidebar3/dynamic-config/configs/sidebar31/secondarySidebarMap";
import type { SidebarConfig } from "app/components/sidebar3/dynamic-config/types";

export const salesSideBarConfig: SidebarConfig = {
    getPrimarySidebarListItems: getSalesItemsList,
    secondarySidebarMap,
};
